import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

const IconCornerM = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 6 6" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.49996 5.99999C5.7761 6 5.99996 5.77614 5.99996 5.49999L5.99999 1.2071C6 0.761651 5.46143 0.538564 5.14644 0.853543L0.85355 5.14636C0.538566 5.46134 0.761642 5.99991 1.20709 5.99992L5.49996 5.99999Z"
        fill="var(--color-typo-primary)"
        fillOpacity="0.35"
      />
    </svg>
  )
}

export const IconCorner = createIcon({
  l: IconCornerM,
  m: IconCornerM,
  s: IconCornerM,
  xs: IconCornerM,
  name: 'IconCorner',
})
